import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconArray(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 4C4 3.44772 4.44772 3 5 3H9C9.55228 3 10 3.44772 10 4C10 4.55229 9.55228 5 9 5H6V19H9C9.55228 19 10 19.4477 10 20C10 20.5523 9.55228 21 9 21H5C4.44772 21 4 20.5523 4 20V4Z"
        fill="currentColor"
      />
      <path
        d="M21 20C21 20.5523 20.5523 21 20 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H19L19 5L16 5C15.4477 5 15 4.55228 15 4C15 3.44771 15.4477 3 16 3H20C20.5523 3 21 3.44771 21 4L21 20Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
